import React from "react";
import { ModeRendererProps } from "./types";

export function MoireMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {Array.from({ length: 2 }).map((_, k) => (
        <g key={k} opacity={0.5}>
          {Array.from({ length: 36 }).map((_, i) => (
            <path key={i} d={`M0 ${i * 32} H 794`} stroke={k === 0 ? brand.aqua : brand.violet} strokeWidth="1" />
          ))}
          <g>
            {Array.from({ length: 24 }).map((_, i) => (
              <path key={i} d={`M${i * 32} 0 V 1123`} stroke={k === 0 ? brand.aqua : brand.amber} strokeWidth="1" />
            ))}
          </g>
        </g>
      ))}
      {Array.from({ length: 14 }).map((_, i) => (
        <path
          key={i}
          d={`M0 ${80 + i * 60} C 200 ${60 + i * 60} 600 ${100 + i * 60} 794 ${80 + i * 60}`}
          stroke={i % 2 ? brand.violet : brand.aqua}
          strokeOpacity="0.25"
          fill="none"
        />
      ))}
    </g>
  );
}
